import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const speedColors = [
  '#d32f2f', // red
  '#f57c00', // orange
  '#fbc02d', // yellow
  '#1976d2', // blue
  '#388e3c', // green
];

const speedRanges = [
  { min: 0, max: 1.5, color: speedColors[0] },
  { min: 1.5, max: 3, color: speedColors[1] },
  { min: 3, max: 4.5, color: speedColors[2] },
  { min: 4.5, max: 6, color: speedColors[3] },
  { min: 6, max: Infinity, color: speedColors[4] },
];

function getRangesWithOff(allPoints) {
  const hasOff = allPoints.some(pt => pt.weedItOff);
  if (hasOff) {
    return [
      {
        min: 'off',
        max: 'off',
        color: '#d32f2f',
        value: 'Weed-It Off',
        dashed: true,
      },
      ...speedRanges
    ];
  }
  return speedRanges;
}

const legendFormatter = r =>
  r.value === 'Weed-It Off'
    ? r.value
    : r.max === Infinity
      ? `${r.min}+`
      : `${r.min} - ${r.max}`;

export default function WeedItSpeedOverlay({ routes }) {
  // routes: array of segments (arrays of points)
  const allPoints = useMemo(() => routes.flat(), [routes]);
  const finalRanges = useMemo(() => getRangesWithOff(allPoints), [allPoints]);

  // If weedItOff is true, treat as "off" (value 'off')
  const valueSelector = pt =>
    pt.weedItOff ? 'off' : (pt.weedItSpeedMph >= 0 ? pt.weedItSpeedMph : 0);

  // Only render overlay if there are points
  if (!allPoints.length) return null;

  return (
    <SegmentedPolylineOverlay
      segments={routes}
      valueSelector={valueSelector}
      ranges={finalRanges}
      legendTitle="Speed Legend (mph)"
      legendFormatter={legendFormatter}
      units="mph"
      discrete={false}
    />
  );
}